'use client';

import { useEffect } from 'react';

export function SetPageTitle({ title }: { title: string }) {
    useEffect(() => {
        const prev = document.title;
        document.title = title;
        return () => {
            document.title = prev;
        };
    }, [title]);
    return null;
}
